export default "__VITE_ASSET__C348DfJE__"